/// <reference path="../../polaris-web-components.d.ts" />
import React, { useEffect, useRef } from 'react';
import { getShopUrl, processCustomerCsv } from '../Services/CommonServices';

export function ValidationErrorModal({ errModalActive, handleErrorChangeModal, uploadErrors, onViewRuleConditions }) {
  var storeUrl = getShopUrl();
  const modalRef = useRef(null);

  useEffect(() => {
    const modal = modalRef.current;
    if (!modal) return;

    if (errModalActive && uploadErrors?.errors?.length > 0) {
      modal.showOverlay();

      const handleHide = (e) => {
        e.stopPropagation();
        if (handleErrorChangeModal) handleErrorChangeModal();
      };
      modal.addEventListener('hide', handleHide);
      return () => modal.removeEventListener('hide', handleHide);
    }
  }, [errModalActive, uploadErrors]);

  // Check if errors contain collection rule-related errors
  const hasRuleErrors = uploadErrors?.errors?.some(error => 
    typeof error === 'string' && (
      error.toLowerCase().includes('rule type') ||
      error.toLowerCase().includes('relation') ||
      error.toLowerCase().includes('allowed')
    )
  );

  const handleViewRuleConditions = (e) => {
    e.stopPropagation(); // Prevent event propagation
    if (onViewRuleConditions) {
      onViewRuleConditions();
    }
  };

  return (
      <s-modal
        ref={modalRef}
        id="validation-error-modal"
        size='large'
        padding='none'
      >
        <s-box padding="none">
          <s-box padding="base">
            <s-heading>
              {uploadErrors?.errorType !== "exception" ? "Issues found in the file" : "Failed"}
            </s-heading>
            <s-banner tone="critical">
              {uploadErrors?.errorType} — {uploadErrors?.errors?.length || 0} issue{uploadErrors?.errors?.length !== 1 ? 's' : ''} found
            </s-banner>
            {hasRuleErrors && onViewRuleConditions && (
              <s-box paddingBlockStart="base">
                <s-banner tone="info">
                  <s-stack direction="inline" gap="small" align="center">
                    <s-text>Need help with rule types and relations?</s-text>
                    <s-link
                      onClick={handleViewRuleConditions}
                    >
                      View Valid Rule Conditions
                    </s-link>
                  </s-stack>
                </s-banner>
              </s-box>
            )}
          </s-box>
          <s-table>
            <s-table-header-row>
              <s-table-header>#</s-table-header>
              <s-table-header>Error</s-table-header>
            </s-table-header-row>
            <s-table-body>
              {uploadErrors?.errors?.map((error, index) => (
                <s-table-row key={index}>
                  <s-table-cell>{index + 1}</s-table-cell>
                  <s-table-cell>
                    <s-text tone="critical">{error}</s-text>
                  </s-table-cell>
                </s-table-row>
              ))}
            </s-table-body>
          </s-table>
        </s-box>

        {uploadErrors?.invalidFileUrl && (
          <s-button 
            slot="secondary-actions" 
            url={uploadErrors.invalidFileUrl}
            variant="tertiary"
            tone="critical"
          >
            Download Invalid File
          </s-button>
        )}

        {uploadErrors?.invalidFileUrl ? (
          <s-button 
            slot="primary-action"
            onClick={() => {
              processCustomerCsv(uploadErrors.validFileUrl, storeUrl);
              if (modalRef.current) modalRef.current.hideOverlay();
              if (handleErrorChangeModal) handleErrorChangeModal();
            }}
          >
            Upload
          </s-button>
        ) : (
          <s-button 
            slot="primary-action"
            onClick={() => {
              if (modalRef.current) modalRef.current.hideOverlay();
              if (handleErrorChangeModal) handleErrorChangeModal();
            }}
          >
            Close
          </s-button>
        )}
      </s-modal>
  );
}

